<template>
  <div>
      <a-card :title="`Application: ${rooms.app_name},Rooms for ${rooms.email} account!`" :bordered="false" v-if="!loading">
        <a-button type="primary" size="small" slot="extra" @click="visible = true">Add new room</a-button>
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Room Name</th>
              <th scope="col">Email</th>
              <th scope="col">Room type</th>
               <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in rooms.rooms" :key="i">
              <th scope="row">{{item.room_id}}</th>
               <th scope="row">{{item.room_name}}</th>
              <th scope="row">{{item.email}}</th>
              <th scope="row">{{item.type == 1 ? 'Basic':'Licensed' }}</th>
              <th scope="row">
                 <a-button type="warning" title="Update!" size="small" @click="editRoomDetails(item.room_id)">
                    <span class="ti-pencil" ></span>
                </a-button> | 
                  <a-popconfirm
                        title="Are you sure delete this room?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="deleteRoom(item.room_id)"
                        @cancel="cancel"
                    >
                        <a-button type="danger" title="Delete!" size="small">
                            <span class="ti-trash"></span>
                        </a-button>
                    </a-popconfirm>
                    </th>
            </tr>
          </tbody>
        </table>

      </a-card>
      <a-modal
            :footer="null"
            title="Add new room!"
            :visible="visible"
            @cancel="cancel"
            >
            <a-row>
              <a-form :form="form" @submit="addNewRoom">
                   <a-form-item label="Room Name">
                    <a-input
                        v-decorator="['room_name', { rules: [{ required: true, message: 'Please insert name!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="Room type">
                    <a-select
                        v-decorator="[
                        'account_type',
                        { initialValue:'1',rules: [{ required: true, message: 'Please select!' }] },
                        ]"
                    >
                        <a-select-option value="1" key="1" selected>
                           Basic
                        </a-select-option>
                        <a-select-option value="2" key="2" >
                           Licensed
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Email">
                    <a-input type="email"
                        v-decorator="['email', { rules: [{ required: true, message: 'Please insert email!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="Large meeting">
                  <a-radio-group v-decorator="['large_meeting',{initialValue:'0'}]">
                    <a-radio value="1">
                    Yes
                    </a-radio>
                    <a-radio value="0">
                    No
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item label="Webinar">
                  <a-radio-group v-decorator="['webinar',{initialValue:'0'}]">
                    <a-radio value="1">
                    Yes
                    </a-radio>
                    <a-radio value="0">
                    No
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-button type="primary" html-type="submit">
                    Submit
                </a-button>
              </a-form>
          </a-row>
      </a-modal>
         <a-modal
            :footer="null"
            title="Edit Room!"
            :visible="editmodal"
            @cancel="cancel"
            >
            <a-row>
              <a-form :form="formedit" @submit="updateRoomdDetails">
                   <a-form-item label="Room Name">
                    <a-input
                        v-decorator="['room_name',
                        {initialValue: room.room_name}, 
                        { rules: [{ required: true, message: 'Please insert name!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="Room type">
                    <a-select
                        v-decorator="[
                        'account_type',
                        { initialValue: room.type,rules: [{ required: true, message: 'Please select!' }] },
                        ]"
                    >
                        <a-select-option value="1" key="1" selected>
                           Basic
                        </a-select-option>
                        <a-select-option value="2" key="2" >
                           Licensed
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Email">
                    <a-input type="email" disabled 
                        v-decorator="['email', {initialValue: room.email, rules: [{ required: true, message: 'Please insert email!' }] }]"
                    />
                </a-form-item>

                 <a-form-item label="Large meeting">
                  <a-radio-group v-decorator="['large_meeting',{initialValue: String(room.large_meeting) }]">
                    <a-radio value="1">
                    Yes
                    </a-radio>
                    <a-radio value="0">
                    No
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item label="Webinar">
                  <a-radio-group v-decorator="['webinar',{initialValue: String(room.webinar) }]">
                    <a-radio value="1">
                    Yes
                    </a-radio>
                    <a-radio value="0">
                    No
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-button type="primary" html-type="submit">
                    Submit
                </a-button>
              </a-form>
          </a-row>
        </a-modal>
  </div>
</template>
<script>

import API from '../../services/api';

export default {
  data() {
    return {
      accid: this.$route.params.id,
      loading: true,
      rooms:{},
      room:{},
      visible:false,
      editmodal:false,
      form: this.$form.createForm(this),
      formedit: this.$form.createForm(this)
    }
  },
  created() {
    this.getRooms()
  },
  methods: {
    getRooms(){
      API.get(`/api/admin/contracts/${this.accid}`)
      .then(response => {
        this.rooms = response.data;
        this.loading = false
      })
    },
    addNewRoom(e){
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          API.post(`/api/admin/accounts/${this.accid}`,values).then(res => {
                if(res.status == 200 && res.data == 'exist'){
                  this.$message.warning('This room exist!')
                }
                if(res.status === 201){
                    this.$message.success('Inserted successfully!')
                    this.getRooms()
                    this.visible = false
                    this.form.resetFields()
                }
          })
        }
      })
    },
    editRoomDetails(roomid){
      this.editmodal = true
      this.room = this.rooms.rooms.filter(item => item.room_id === roomid)[0]
    },
    updateRoomdDetails(e){
       e.preventDefault();
      this.formedit.validateFields((err, values) => {
        if (!err) {
          API.put(`/api/admin/accounts/rooms/${this.room.room_id}`,values).then(res => {
               if(res.status === 200){
                    this.$message.success('Updated successfully!')
                    this.getRooms()
                    this.editmodal = false
                }
          })
        }
      })
    },
    deleteAccount(id){
      API.delete(`/api/admin/contracts/account/${id}`)
      .then(response => {
       
      })
    },
    deleteRoom(hostid){
        API.delete(`/api/admin/hosts/${hostid}`)
        .then(response => {
            this.$message.success('Deleted successfully!')
            this.getRooms()
        })
    },
    removeRoom(hostid){
        API.delete(`/api/admin/rooms/${hostid}`)
        .then(response => {
            this.$message.success('Removed successfully!')
            this.getRooms()
        })
    },
    cancel(){
      this.visible = false
      this.editmodal = false
    },
    async resetForm(){
       this.form = {
          email:'',
          room_name:'',
          account_type:''
        }
    },
  },
};
</script>
<style>
</style>
